export const warehouseUIProfiles = {
    warehouseAdmin: {
        showDealerColumn: true,
        showDealerSelect: true,
        editRecipient: true,
        canChooseDealer: true,
        canLoadDealers: false
    },
    warehouseUser: {
        showDealerColumn: false,
        showDealerSelect: true,
        editRecipient: false,
        canChooseDealer: false,
        canLoadDealers: true
    },
    DEFAULT: {
        showDealerColumn: false,
        showDealerSelect: false,
        editRecipient: false,
        canChooseDealer: false,
        canLoadDealers: false
    }
}